(() => {
  const L_ = window.SVL_I18N || {};
  const V_ = (x) => (L_.vals && L_.vals[x]) || x;
  const pad = (i) => String(Number(i) + 1).padStart(2, "0");
  const MONTHS = (L_.months && L_.months.length === 12) ? L_.months : ["January","February","March","April","May","June","July","August","September","October","November","December"];

  document.querySelectorAll("[data-svb]").forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = "true";

    const config = JSON.parse(root.querySelector("[data-config]").textContent);
    const t = config.strings;
    const pieces = [...root.querySelectorAll("[data-piece]")];
    const form = root.querySelector("form");
    const button = root.querySelector("[data-submit]");
    const error = root.querySelector("[data-error]");
    let quantity = Number(root.dataset.quantity) || 2;
    let busy = false;
    const pickers = [];

    const closePickers = () => pickers.forEach((p) => { p.menu.hidden = true; p.trigger.setAttribute("aria-expanded", "false"); });

    /* ---------- listes déroulantes maison, avec la vignette de la pierre ---------- */
    root.querySelectorAll("select").forEach((select, index) => {
      const picker = document.createElement("div");
      picker.className = "svb-stone-picker";
      picker.dataset.bundlePicker = "";

      const trigger = document.createElement("button");
      trigger.type = "button";
      trigger.className = "svb-stone-picker__button";
      trigger.setAttribute("aria-haspopup", "listbox");
      trigger.setAttribute("aria-expanded", "false");
      const label = select.closest("label, div").querySelector(".svb__label");
      label.id = root.id + "-label-" + index;
      trigger.setAttribute("aria-labelledby", label.id + " " + root.id + "-value-" + index);

      const preview = document.createElement("img");
      preview.alt = ""; preview.hidden = true; preview.width = 24; preview.height = 24;
      const value = document.createElement("span");
      value.className = "svb-stone-picker__value";
      value.id = root.id + "-value-" + index;
      const caret = document.createElement("span");
      caret.className = "svb-stone-picker__caret";
      caret.setAttribute("aria-hidden", "true");
      trigger.append(preview, value, caret);

      const menu = document.createElement("div");
      menu.className = "svb-stone-picker__menu";
      menu.setAttribute("role", "listbox");
      menu.setAttribute("aria-labelledby", label.id);
      menu.hidden = true;

      const fieldError = document.createElement("span");
      fieldError.className = "svb__field-error";
      fieldError.hidden = true;
      fieldError.textContent = select.options[0].textContent;

      const choices = [];
      [...select.options].filter((o) => o.value !== "").forEach((option) => {
        const choice = document.createElement("button");
        choice.type = "button";
        choice.className = "svb-stone-picker__option";
        choice.setAttribute("role", "option");
        option.dataset.image = config.stones[Number(option.value)];
        const img = document.createElement("img");
        img.src = option.dataset.image; img.alt = ""; img.width = 32; img.height = 32; img.loading = "lazy";
        const text = document.createElement("span");
        text.textContent = option.textContent;
        choice.append(img, text);
        menu.append(choice);
        choices.push({ choice, option });
        choice.addEventListener("click", () => {
          if (busy) return;
          select.value = option.value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
          closePickers();
          trigger.focus();
        });
      });

      const update = () => {
        const selected = select.selectedOptions[0];
        value.textContent = selected ? selected.textContent : "";
        preview.hidden = !(selected && selected.dataset.image);
        if (!preview.hidden) preview.src = selected.dataset.image;
        trigger.disabled = select.matches(":disabled");
        const invalid = select.getAttribute("aria-invalid") === "true";
        trigger.setAttribute("aria-invalid", String(invalid));
        fieldError.hidden = !invalid || trigger.disabled;
        choices.forEach(({ choice, option }) => choice.setAttribute("aria-selected", String(option.value === select.value)));
        if (trigger.disabled) { menu.hidden = true; trigger.setAttribute("aria-expanded", "false"); }
      };

      trigger.addEventListener("click", () => {
        const open = menu.hidden;
        closePickers();
        menu.hidden = !open;
        trigger.setAttribute("aria-expanded", String(open));
      });
      picker.addEventListener("keydown", (event) => {
        const available = choices.map((c) => c.choice).filter((c) => !c.disabled);
        if (event.key === "Escape") { event.preventDefault(); closePickers(); trigger.focus(); }
        else if (["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)) {
          event.preventDefault();
          menu.hidden = false; trigger.setAttribute("aria-expanded", "true");
          const i = available.indexOf(document.activeElement);
          const next = event.key === "Home" ? 0 : event.key === "End" ? available.length - 1
            : event.key === "ArrowDown" ? (i + 1) % available.length : i <= 0 ? available.length - 1 : i - 1;
          if (available[next]) available[next].focus();
        }
      });
      picker.addEventListener("focusout", (event) => {
        if (!picker.contains(event.relatedTarget)) { menu.hidden = true; trigger.setAttribute("aria-expanded", "false"); }
      });

      picker.append(trigger, menu);
      select.after(picker);
      picker.after(fieldError);
      select.hidden = true;
      select.tabIndex = -1;
      select.setAttribute("aria-hidden", "true");
      select.addEventListener("change", update);
      select._trigger = trigger;
      pickers.push({ trigger, menu, update });
      update();
    });
    document.addEventListener("click", (event) => { if (!event.target.closest("[data-bundle-picker]")) closePickers(); });

    /* ---------- état ---------- */
    const selectedVariant = (piece) => {
      const color = piece.querySelector("[data-color][aria-pressed=true]").dataset.color;
      return config.variants.find((v) => v.option1 === color);
    };
    const showError = (message) => { error.textContent = message; error.hidden = false; };

    /* l'aperçu : les deux pierres choisies, côte à côte, comme sur le pendentif */
    const renderPreview = (piece) => {
      const body = piece.querySelector("[data-preview-body]");
      if (!body) return;
      const left = piece.querySelector("[data-left]").value;
      const right = piece.querySelector("[data-right]").value;
      if (left === "" || right === "") {
        body.innerHTML = '<p class="svb__preview-empty">' + t.previewEmpty + "</p>";
        return;
      }
      const stone = (index) =>
        '<span class="svb__preview-stone"><img src="' + config.stones[Number(index)] + '" alt="" width="34" height="34" loading="lazy"><span>' +
        MONTHS[Number(index)] + "</span></span>";
      body.innerHTML = stone(left) + '<span class="svb__preview-heart" aria-hidden="true">&#9829;</span>' + stone(right);
    };

    const sync = () => {
      root.dataset.quantity = quantity;
      root.querySelectorAll(".svb__choice").forEach((b) => {
        b.setAttribute("aria-pressed", String(Number(b.dataset.quantity) === quantity));
        b.disabled = busy;
      });
      pieces.forEach((piece, index) => {
        piece.hidden = index >= quantity;
        piece.disabled = index >= quantity || busy;
        const v = selectedVariant(piece);
        const note = piece.querySelector("[data-availability]");
        note.hidden = !v || v.available;
        note.textContent = t.unavailable;
        renderPreview(piece);
      });
      button.disabled = busy;
      button.textContent = busy ? t.busy : (quantity === 2 ? t.two : t.one);
      pickers.forEach((p) => p.update());
    };

    root.querySelectorAll(".svb__choice").forEach((b) => b.addEventListener("click", () => {
      if (busy) return;
      quantity = Number(b.dataset.quantity);
      error.hidden = true;
      sync();
    }));

    /* la galerie du thème suit la couleur choisie sur le premier collier */
    const showMedia = (color) => {
      const variant = config.variants.find((v) => v.option1 === color);
      if (!variant || !variant.mediaId) return;
      const item = document.querySelector('[data-target$="-' + variant.mediaId + '"]');
      if (!item) return;
      const target = item.querySelector("button, a, [role=button]") || item;
      target.click();
    };

    pieces.forEach((piece) => {
      piece.querySelectorAll("[data-color]").forEach((b) => b.addEventListener("click", () => {
        if (busy) return;
        piece.querySelectorAll("[data-color]").forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
        piece.querySelector("[data-color-label]").textContent = V_(b.dataset.color);
        sync();
        if (piece === pieces[0]) showMedia(b.dataset.color);
      }));
      piece.querySelectorAll("select").forEach((s) => s.addEventListener("change", () => {
        s.removeAttribute("aria-invalid");
        error.hidden = true;
        sync();
      }));
    });

    /* ---------- ajout au panier → tiroir Revive (LuminTheme) ---------- */
    const refreshDrawer = async (data) => {
      const drawer = document.querySelector("cart-drawer");
      if (!drawer || typeof drawer.renderContents !== "function") {
        window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : "/cart";
        return;
      }
      const ids = drawer.getSectionsToRender().map((s) => s.id);
      if (!data.sections || ids.some((id) => !data.sections[id])) {
        const r = await fetch(`${window.location.pathname}?sections=${ids.join(",")}`);
        data = { sections: await r.json() };
      }
      drawer.classList.remove("is-empty");
      drawer.renderContents(data);
      drawer.open();
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        const cart = await fetch((window.routes ? window.routes.cart_url : "/cart") + ".js").then((r) => r.json());
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "eneck-bundle", cartData: cart });
      }
    };

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (busy) return;
      error.hidden = true;

      const active = pieces.slice(0, quantity);
      const fields = active.flatMap((r) => [...r.querySelectorAll("select")]);
      const missing = fields.filter((s) => s.value === "");
      fields.forEach((s) => s.setAttribute("aria-invalid", String(missing.includes(s))));
      pickers.forEach((p) => p.update());
      if (missing.length) { showError(t.required); missing[0]._trigger.focus(); return; }

      const items = active.map((r) => {
        const variant = selectedVariant(r);
        if (!variant || !variant.available) return null;
        return {
          id: variant.id,
          quantity: 1,
          properties: {
            [L_.propLeft || "Left birthstone"]: MONTHS[Number(r.querySelector("[data-left]").value)],
            [L_.propRight || "Right birthstone"]: MONTHS[Number(r.querySelector("[data-right]").value)],
            // code atelier, masque au client par le prefixe _
            "_stone_ref": pad(r.querySelector("[data-left]").value) + " / " + pad(r.querySelector("[data-right]").value)
          }
        };
      });
      if (items.some((i) => !i)) { showError(t.unavailable); return; }

      busy = true;
      sync();
      try {
        const drawer = document.querySelector("cart-drawer");
        const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
        // le panier remonte la dernière ligne ajoutée en premier : on envoie le 2e collier d'abord
        const response = await fetch((window.routes ? window.routes.cart_add_url : "/cart/add") + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items.slice().reverse(), sections, sections_url: window.location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || t.error);
        await refreshDrawer(data);
      } catch (e) {
        showError(e.message || t.error);
      } finally {
        busy = false;
        sync();
      }
    });

    sync();
  });
})();

